module.exports = __webpack_public_path__ + "static/austy-847568ce220cd0cc824c966bb0caf278.gif";